// Copyright (c) 2026 Vigeos SASU. Tous droits réservés.
import React from 'react';
import { Box, InputAdornment, TextField, Tooltip, Typography, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Close';

/**
 * Champ de recherche commun à tous les écrans du back-office. Le libellé par
 * défaut nomme les trois axes cherchés (nom, établissement, localisation) ; un
 * écran qui cherche ailleurs le dit par son propre `placeholder`. `account` et
 * `total` affichent « 12 sur 40 » dès qu'un filtre retranche quelque chose,
 * pour qu'une recherche trop étroite ne se lise pas comme une liste vide.
 */
export default function ChampRecherche({
  valeur,
  onChange,
  placeholder = 'Rechercher par nom, établissement ou localisation',
  compte: account = null,
  total = null,
  nomObjet: itemNoun = 'résultat',
  sx = {},
  autoFocus = false,
}) {
  const activeFilter = String(valeur || '').trim().length > 0;
  const showCount = account !== null && total !== null;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1, minWidth: 260, ...sx }}>
      <TextField
        size="small"
        value={valeur}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
        sx={{ flex: 1, minWidth: 240 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment>
          ),
          endAdornment: activeFilter ? (
            <InputAdornment position="end">
              <Tooltip title="Effacer la recherche">
                <IconButton size="small" onClick={() => onChange('')} edge="end">
                  <ClearIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ) : null,
        }}
      />
      {showCount && activeFilter && (
        <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
          {account} sur {total} {itemNoun}{total > 1 ? 's' : ''}
        </Typography>
      )}
    </Box>
  );
}
